import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  MenuItem,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  useMediaQuery,
   Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    InputAdornment,
    DialogTitle,
    DialogActions,
    Checkbox,
    Popover, 
} from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { useFormik } from "formik";
import {
  useCreateModifierGrpMutation,
  useGetAllMainCategoryQuery,
  useGetLastProductIdQuery,
  useGetPrinterQuery,
  useGetProductBrandQuery,
  useGetProductTagQuery,
  useGetSubCategoryByArrayQuery,
  useGetProductQuery,
  useGetModifierQuery,
  useGetCategoryQuery,
  useGetShopQuery
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {
  ICategory,
  ILastProductId,
  IPrinter,
  IProduct,
  IModifierPopUp,
  IModifierGrp,
  IProductPopUP,
  IProductBrand,
  IProductTag,
  ModifierInfo,
  ProductInfo,
  IShop
} from "../../../Api/Interface/api.interface";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Switch, { SwitchProps } from "@mui/material/Switch";
import AddIcon from "@mui/icons-material/Add";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import CustomSwitch from "../../../Components/Switch/CustomSwitch";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import { HexColorPicker } from "react-colorful";
import Barcode from "react-barcode";
import AppsIcon from "@mui/icons-material/Apps";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import NewProductBrand from "../../ProductBrand/Edit/index";
import NewPrinter from "../../Printer/Edit/index";
import NewProductTag from "../../ProductTags/Edit/index";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import { uploadImage } from "../../../Components/UploadFile/upload";
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import { CiSearch } from "react-icons/ci";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


const steps = ["Basic Details", "Looping Table", "Done"];

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(28px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 30, // Increased thumb size
    height: 30, // Increased thumb size
  },
  "& .MuiSwitch-track": {
    borderRadius: 34 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#757575" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`, // Using SVG path for check
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`, // Using SVG path for minus
      right: 12,
    },
  },
}));



interface IShopProductPopup {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  shopId: number;
  selectedShopProducts: number[];
  setSelectedShopProducts: (ids: number[]) => void;
  onSuccess?: () => void; 
}

const Index = ({
   openModel = false,
  handleCloseDialog,
  shopId,
  selectedShopProducts,
  setSelectedShopProducts,
  onSuccess, 
}: IShopProductPopup ) => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const gridHeight = isMobile ? "30px" : "400px";
   const [open] = React.useState(openModel);
   const API_URL = (process.env.REACT_APP_API_URL || "").trim();

  // const [newModifierGroup, { isLoading }] = useCreateModifierGrpMutation();
   const [currentSearchQueryProduct, setCurrentSearchQueryProduct] =useState<string>("");
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  // For selecting rows
const [selectedRows, setSelectedRows] = useState<Record<number, boolean>>({});

// For dropdown menu
const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);


// For Price Dialog
const [openPriceDialog, setOpenPriceDialog] = useState(false);
const [priceValue, setPriceValue] = useState("");
const [productIds, setProductIds] = React.useState<number[]>([]);

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();
  // const { data: categoryData } = useGetAllMainCategoryQuery({
  //   departmentId: "",
  //   coursingId: "",
  //   roleId: null,
  //   taxeId: "",
  //   createdDateStart: null,
  //   createdDateEnd: null,
  //   searchText: "",
  //   numberOfLength: 0,
  //   isActive: true,
  //   categoryIsLooping: null,
  //   createdDate: null,
  // });

 


  const { data: modifierData } = useGetModifierQuery({
     productBrandId:  null,
    productCategoryId:  null,
    productTagIds: null,
    modifierViewOnline:null,
    createdDateEnd:  null,
    createdDateStart:null,
    searchText: null,
    createdDate: null,
    id:  "",
    });

  const { data: productBrandData, isLoading: ProductBrandLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });
  const { data: productTagData, isLoading: ProductTagLoading } =
    useGetProductTagQuery({
      searchText: "",
      isActive: true,
    });
  const { data: printerData, isLoading: PrinterLoading } = useGetPrinterQuery({
    searchText: "",
  });

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);
 

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);

  const [openProductCategory, setOpenProductCategory] = useState(false);
  const [openProductBrand, setOpenProductBrand] = useState(false);
  const [openProductTag, setOpenProductTag] = useState(false);
  const [openPrinter, setOpenPrinter] = useState(false);
  const [selectedColor, setSelectedColor] = useState<string>("#FFFFFF");
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorPickerRef = useRef<HTMLDivElement>(null);
  const { data: newLastProductIdData, isLoading: lastProductIdIsLoading } =
    useGetLastProductIdQuery();
  const [showBarcode, setShowBarcode] = useState(false);

  const [openLoopingCategoryDialog, setOpenLoopingCategoryDialog] =
    useState(false);
    const [overwriteChoice, setOverwriteChoice] = useState<Record<number, 'yes' | 'no'>>({});
   const [overwritePrices, setOverwritePrices] = useState<Record<number, number>>({});
const [modifiers, setModifiers] = React.useState<ModifierInfo[]>([]);
const [products, setProducts] = React.useState<ProductInfo[]>([]);
const selectedModifierIds = modifiers.map((m) => m.modifier_id);

  const [openGallery, setOpenGallery] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File | undefined>(
    undefined
  );

       const productCategoryId = selectedSubToSubToSubCategoryId
    ? Number(selectedSubToSubToSubCategoryId)
    : selectedSubToSubCategoryId
    ? Number(selectedSubToSubCategoryId)
    : selectedSubCategoryId
    ? Number(selectedSubCategoryId)
    : selectedCategoryId
    ? Number(selectedCategoryId)
    : String("");

    const {
    data: productData,
    isLoading: productIsLoading,
    refetch: productRefetch,
  } = useGetProductQuery({
    productBrandId: null,
    productCategoryId: "",
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    searchText: currentSearchQueryProduct,
    createdDate: null,
    id: null,
  });

    const { data, isLoading, isError, refetch } = useGetShopQuery({
        searchText: "",
        id: String(shopId),     
      });

    const shopList = useMemo(() => {
      if (data && Array.isArray(data.data) && data.data.length > 0) {
        return data.data[0] as IShop;
      }
      return null;
    }, [data]);

 

 
 const productList: IProductPopUP[] = Array.isArray(productData?.data)
    ? (productData?.data as IProductPopUP[])
    : [];

 const filteredShopProducts = React.useMemo(() => {
  return productList.filter((p) => productIds.includes(Number(p.id)));
}, [productList, productIds]);

          const modifierList = useMemo(() => {
        return modifierData?.data as IModifierPopUp[];
      }, [modifierData?.data]);

    const categoryList = useMemo(() => {
      return categoryData?.data as ICategory[];
    }, [categoryData?.data]);

    React.useEffect(() => {
      if (shopList?.product_ids) {
        const ids =
          typeof shopList.product_ids === "string"
            ? JSON.parse(shopList.product_ids)
            : shopList.product_ids;
    
        setProductIds(ids || []); // similar to setRouteIds
      }
    }, [shopList]);

  const formik = useFormik({
  initialValues: {},
  onSubmit: async (_, { resetForm }) => {
    try {
      if (products.length === 0) {
        showErrorMessage("Please select at least one product");
        return;
      }

      setLoading(true);

      const token = localStorage.getItem("token") || "";

    const newIds = products.map((p) => Number(p.product_id));

      // Combine with existing productIds from shop, prevent duplicates
      const updatedIds = [
        ...productIds,
        ...newIds.filter((id) => !productIds.includes(id)),
      ];

      // Send combined list to backend
      const res = await fetch(`${API_URL}/shops/${shopId}/update-product`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          product_ids: updatedIds,
        }),
      });

      const data = await res.json();

      if (!res.ok || !data.status) {
        throw new Error(data.message || "Failed to update products");
      }

      showMessage(data.message);
      setProductIds(updatedIds);
      // optional UI updates
      resetForm();
      setProducts([]);
      handleClose();
      if (onSuccess) onSuccess();

    } catch (error: any) {
      console.error(error);
      showErrorMessage(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  },
});

  // const formValid = useMemo(() => {
  //   return formik.values.modifierGroupName === "" ||
  //     formik.values.modifierGroupName === undefined
  //     ? false
  //     : true;
  // }, [formik]);

  


const applyBulkToggle = (field: "pos" | "online") => {
  const updated = products.map((item: ProductInfo) =>
    selectedRows[Number(item.product_id)]
      ? { ...item, [field]: !item[field] }
      : item
  );
  setProducts(updated);
};

  const handleClose = () => {
    handleCloseDialog(false);
  };



const applyPriceUpdate = () => {
  const updated = products.map((item: ProductInfo) =>
    selectedRows[Number(item.product_id)]
      ? { ...item, price: Number(priceValue) }
      : item
  );
  setProducts(updated);
  setOpenPriceDialog(false);
};



  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        colorPickerRef.current &&
        !colorPickerRef.current.contains(event.target as Node)
      ) {
        setShowColorPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  


const handleAddModifier = (product: IProductPopUP) => {
  const alreadyAdded = products.some((m) => Number(m.product_id) === Number(product.id));
  if (!alreadyAdded) {
    setProducts([
      ...products,
      {
        product_id: String(product.id),
      },
    ]);
  }
};


const handleMainCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const categoryId = event.target.value as number;
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
    formik.setFieldValue("mainCatId", categoryId);

    const selectedCategory = categoryList.find(
      (category) => category.id == categoryId
    );

    if (selectedCategory) {
      formik.setFieldValue(
        "productDetailsIsLooping",
        selectedCategory.categoryIsLooping
      );
      formik.setFieldValue(
        "productsDetailsLoopingConstant",
        selectedCategory.categoryLoopingConstant
      );
    }
  };

  
  if (
    isLoading ||
    ProductBrandLoading ||
    ProductTagLoading ||
    PrinterLoading ||
    lastProductIdIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const cancelFunction = () => {
    formik.resetForm();
    setSelectedImage(undefined);
    setOpenGallery(false);
    setSelectedCategoryId(null);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
  };

 


  return (
   

 <Dialog
         open={open}
         onClose={handleClose}
           fullWidth
         PaperProps={{
           style: {
             maxWidth: "1700px",
           },
         }}
       >
  <Grid className={classes.Dialog}>
    <Grid container spacing={3}>
        <Grid item lg={4} md={4} sm={12} xs={12}>
          <Card className={classes.stepperCard}  sx={{ mb: 2 }}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >

<Grid container spacing={3} p={"5px"}>
                 

                            

                             <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="center">

                                <TextField
                                 label="Category"
                                                   select
                                                   fullWidth
                                                   size="small"
                                                   className={classes.textField}
                                                   value={selectedCategoryId ?? ""}
                                                   onChange={handleMainCategoryChange}
                                                   InputLabelProps={{ shrink: true }}
                                                 >
                                                   <MenuItem
                                                     value=""
                                                     style={{ color: "gray" }}
                                                   >
                                                     Select Category
                                                   </MenuItem>
                                                   <MenuItem value={-1}>
                                                     All Products
                                                   </MenuItem>
                                                   {categoryList &&
                                                     categoryList
                                                     .filter((category) => !category.parent_ids || category.parent_ids.length === 0)
                                                     .map((category) => (
                                                       <MenuItem
                                                         key={category.id}
                                                         value={category.id}
                                                       >
                                                         {category.categoryName}
                                                       </MenuItem>
                                                     ))}
                                                 </TextField>
                                                 </Grid></Grid>



  <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="center">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search product.."
                sx={{ width: "100%" }}
                size="small"
              />
            </Grid>
  </Grid>
  

                                                 </Grid>


              </Grid>
            </Grid>
          </Card>


           <Card className={classes.stepperCard} sx={{height: 340, overflowY: 'auto'}}>
          <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                       Product List
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"5px"}>
                                         

        {selectedCategoryId && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
<Box sx={{ padding: 2, maxHeight: 400, overflowY: "auto" }}>
  {(() => {

        // Step 1: Collect all child category IDs including itself
        const isAllProducts = Number(selectedCategoryId) === -1;
        const relatedCategoryIds = isAllProducts ? [] : [
          Number(selectedCategoryId),
          ...categoryList
            .filter(
              (cat) =>
                cat.parent_ids &&
                Array.isArray(cat.parent_ids) &&
                cat.parent_ids.includes(Number(selectedCategoryId))
            )
            .map((cat) => Number(cat.id)),
        ];

        // Step 2: Filter products belonging to any of these categories
  const filtered = productList.filter(
  (mod) =>
    (isAllProducts || relatedCategoryIds.includes(Number(mod.productCategoryId))) &&
    mod.productName.toLowerCase().includes(searchText.toLowerCase()) &&
    !products.some((p) => Number(p.product_id) === Number(mod.id)) &&
    !filteredShopProducts.some((p) => Number(p.id) === Number(mod.id))
);



        return filtered.length > 0 ? (
          <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
              <Typography fontSize={13} color="text.secondary">{filtered.length} product{filtered.length !== 1 ? "s" : ""} found</Typography>
              <Button
                variant="contained"
                size="small"
                onClick={() => {
                  const newProducts = filtered
                    .filter((mod) => !products.some((p) => Number(p.product_id) === Number(mod.id)))
                    .map((mod) => ({ product_id: String(mod.id) }));
                  setProducts([...products, ...newProducts]);
                }}
                sx={{ textTransform: "none", fontSize: 12, fontWeight: 600 }}
              >
                Select All ({filtered.length})
              </Button>
            </Box>
            {filtered.map((mod) => (
            <Box
              key={mod.id}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={1}
            >
              <Typography>{mod.productName}</Typography>
              <Button
                variant="outlined"
                size="small"
                onClick={() => handleAddModifier(mod)}
              >
                Add
              </Button>
            </Box>
          ))}
          </>
        ) : (
          <Typography
            sx={{ textAlign: "center", padding: 2}}
          >
            No products found
          </Typography>
        );
      })()}
    </Box>
  </Grid>
)}

                  
 
                    </Grid>
                  </Card>
                </Grid>

              
        
        <Grid item lg={8} md={8} sm={12} xs={12}>
         
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card} sx={{ height:500, overflowY: 'auto' }}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
                      <Typography className={classes.cardTitle}>
                       Selected products
                      </Typography>
                    </Grid>

  {/* <Grid
          item
          lg={8}
          md={8}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
           
            <Grid item>
              <Button
                variant="contained"
                className={classes.addButton}
                endIcon={<ArrowDropDownIcon />}
                 onClick={(e) => setAnchorEl(e.currentTarget)}
              >
                Edit
              </Button>
            </Grid>
          </Grid>
        </Grid> */}

                  </Grid>



   {selectedCategoryId && (
          
  <Grid>
     
     <TableContainer>
    <Table className={classes.table}>
      <TableHead className={classes.tableHeaderRow}>
        <TableRow>
            <TableCell className={classes.tablheader}> <strong>#</strong></TableCell>
          <TableCell className={classes.tablheader}><strong>Product Name</strong></TableCell>
          {/* <TableCell className={classes.tablheader}><strong>Price</strong></TableCell>
            <TableCell className={classes.tablheader}><strong>Online</strong></TableCell>
              <TableCell className={classes.tablheader}><strong>POS</strong></TableCell> */}
          {/* <TableCell className={classes.tablheader}><strong>Overwrite?</strong></TableCell>
          <TableCell className={classes.tablheader}><strong>Overwrite Price</strong></TableCell> */}
          <TableCell className={classes.tablheader}><strong>Action</strong></TableCell>
            {/* <TableCell className={classes.tablheader}>
                <Checkbox
  checked={
    products.length > 0 &&
    products.every((item) => selectedRows[Number(item.product_id)])
  }
  indeterminate={
    products.some((item) => selectedRows[Number(item.product_id)]) &&
    !products.every((item) => selectedRows[Number(item.product_id)])
  }
  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
    const newSelected: Record<number, boolean> = {};
    if (e.target.checked) {
      products.forEach((item: ProductInfo) => {
        newSelected[Number(item.product_id)] = true;
      });
    }
    setSelectedRows(newSelected);
  }}
/>



                          </TableCell> */}
        </TableRow>
      </TableHead>
    <TableBody>
  {products.map((mod, index) => {
    const modInfo = productList.find((m) => Number(m.id) === Number(mod.product_id));
    return (
      <TableRow key={mod.product_id}>
      <TableCell scope="row" className={classes.tablCell}>
                        { index + 1}
                      </TableCell>
        <TableCell scope="row" className={classes.tablCell}>{modInfo?.productName}</TableCell>
    {/* <TableCell>
  <TextField
    type="number"
    size="small"
    value={mod.price || ""}
     onChange={(e) => {
        const value = e.target.value;
  const updated = [...products];
  updated[index] = {
    ...updated[index],
    price: value === "" ? 0 : Number(value), 
  };

  setProducts(updated);
}}
  
    sx={{ width: 100 }}
  />
</TableCell>

       <TableCell>
  <IOSSwitch
    checked={mod.online ?? false}
    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
      const updated = [...products];
      updated[index] = {
        ...updated[index],
        online: event.target.checked, //  use checked
      };
      setProducts(updated);
    }}
  />
</TableCell> */}

{/* POS SWITCH */}
{/* <TableCell>
  <IOSSwitch
    checked={mod.pos ?? false}
    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
      const updated = [...products];
      updated[index] = {
        ...updated[index],
        pos: event.target.checked, 
      }
      setProducts(updated);
    }}
  />
</TableCell> */}

      
        <TableCell  scope="row" className={classes.tablCell}>
           <IconButton
    size="small"
    color="error"
    onClick={() => {
      const updated = products.filter(
        (item) => item.product_id !== mod.product_id
      );
      setProducts(updated);
    }}
      sx={{
      backgroundColor: '#f8d7da',
      borderRadius: '50%',
      padding: '4px',
      '&:hover': {
        backgroundColor: '#f1b0b7',
      },
    }}
  >
    <CloseIcon fontSize="small" />
  </IconButton>
        </TableCell>

          {/* <TableCell className={classes.tablCell}>
                    <Checkbox
  checked={selectedRows[Number(mod.product_id)] || false}
  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedRows({
      ...selectedRows,
      [Number(mod.product_id)]: e.target.checked,
    });
  }}
/>




                              </TableCell> */}
      </TableRow>
    );
  })}
</TableBody>

    </Table>
    </TableContainer>
  
  </Grid>
     )}


                </Card>
              </Grid>

           
            </Grid>
       
        </Grid>





  <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                        <Box m={0.5}></Box>

                        <Button
                          variant="contained"
                          startIcon={<SaveAltIcon />}
                          className={classes.addButton}
                          onClick={() => formik.handleSubmit()}
                          //disabled={!formValid || isLoading}
                            disabled={  loading}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
          </Card>
          
        </Grid>

      </Grid>
</Grid>

<Popover
  open={Boolean(anchorEl)}
  anchorEl={anchorEl}
  onClose={() => setAnchorEl(null)}
  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
>
  <MenuItem
    onClick={() => {
      setAnchorEl(null);
      setOpenPriceDialog(true);
    }}
  >
    Price
  </MenuItem>

  <MenuItem
    onClick={() => {
      applyBulkToggle("pos");
      setAnchorEl(null);
    }}
  >
    POS
  </MenuItem>

  <MenuItem
    onClick={() => {
      applyBulkToggle("online");
      setAnchorEl(null);
    }}
  >
    Online
  </MenuItem>
</Popover>

<Dialog open={openPriceDialog} onClose={() => setOpenPriceDialog(false)}>
  <DialogTitle>Update Price</DialogTitle>

  <DialogContent>
    <TextField
      label="Enter Price"
      type="number"
      fullWidth
      size="small"
      value={priceValue}
      onChange={(e) => setPriceValue(e.target.value)}
       inputProps={{ min: 0 }} 
    />
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenPriceDialog(false)}>Cancel</Button>

    <Button variant="contained" onClick={applyPriceUpdate}>
      Apply
    </Button>
  </DialogActions>
</Dialog>


</Dialog>
   

  );
};

export default Index;
